// extracted by mini-css-extract-plugin
export default {"printOptions":"printOptions-IzHHk","printButtons":"printButtons-wsxZG"};